<template>
    <div id="inner-auth-content" class="d-flex flex-column align-center justify-left">
        <div class="d-flex justify-center align-center">
            <h4 style="color: dimgrey">{{ $t('auth.recovery.title') }}</h4>
        </div>

        <div class="d-flex align-center mt-8">
            <span class="d-flex justify-center responsive-auth-font" style="color: darkgrey; width: 450px"> {{ $t('auth.recovery.intro') }} </span>
        </div>

        <v-form class="mt-6" ref="form" lazy-validation style="width: 300px">
            <div class="d-flex justify-center align-center">
                <v-text-field v-model="form.email" :rules="[rules.required, rules.email]" type="email" label="Email" autocomplete="email" autofocus dense class="mb-3 left-input" data-cy="email"></v-text-field>
            </div>

            <div class="d-flex justify-start align-center">
                <p v-if="form.errors && form.errors.email" data-cy="error-email" class="red--text subtitle-2 mb-3">
                    {{ tServer(String(form.errors.email)) }}
                </p>
            </div>

            <div class="d-flex justify-start align-center">
                <p v-if="form.errors && form.errors.message" class="red--text subtitle-2 mb-0" data-cy="error-message">
                    {{ tServer(String(form.errors.message)) }}
                </p>
            </div>

            <div class="d-flex justify-start align-center" style="margin-top: -25px">
                <p v-if="success" class="text-center green--text subtitle-2 mb-0" data-cy="success-message">
                    {{ tServer(success) }}
                </p>
            </div>

            <div class="d-flex justify-center">
                <v-btn @click="submitForm" :loading="loading" class="mt-6 myprovet-btn-ok" data-cy="submit-button"> {{ $t('auth.recovery.submit') }} </v-btn>
            </div>
        </v-form>

        <div class="responsive-auth-login-link">
            <span class="d-flex justify-left responsive-auth-font" style="color: darkgrey">
                {{ $t('auth.recovery.remembered') }}

                <inertia-link class="no-underline" href="/"> &nbsp;{{ $t('auth.recovery.loginLink') }}</inertia-link>
            </span>

            <span class="d-flex mt-1 justify-left responsive-auth-font" style="color: darkgrey">
                {{ $t('auth.newHere') }}

                <inertia-link class="no-underline" href="/register"> &nbsp;{{ $t('auth.registerHere') }}</inertia-link>
            </span>
        </div>

        <social-media-auth> </social-media-auth>
    </div>
</template>

<script>
import AuthLayout from '../Layouts/AuthLayout';
import { i18n } from '@/i18n';

export default {
    props: {
        success: String,
    },

    data() {
        return {
            form: {
                email: null,
                errors: null,
            },
            rules: {
                required: (value) => (value && !!value) || i18n.t('validation.required'),
                email: function (value) {
                    var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    return value && re.test(value) ? true : i18n.t('userDetails.rules.invalidEmail');
                },
            },
            loading: false,
        };
    },

    methods: {
        submitForm() {
            if (!this.$refs.form.validate()) return;

            this.loading = true;

            this.$inertia.post('/forgot-password', this.form, {
                onSuccess: () => {
                    this.loading = false;
                    this.form.errors = null;

                    this.showSuccess(this.$t('auth.recovery.sent'));
                },
                onError: (errors) => {
                    this.loading = false;
                    this.form.errors = errors;
                },
            });
        },
    },

    layout: AuthLayout,
};
</script>

<style scoped>
.no-underline {
    text-decoration: none;
}
</style>
